import script from "./ProductSimpleSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSimpleSelect.vue?vue&type=script&setup=true&lang=js"

import "./ProductSimpleSelect.vue?vue&type=style&index=0&id=fd7403c4&lang=css"

const __exports__ = script;

export default __exports__